import { useQuery } from "@tanstack/react-query";
import Axios from "axios";
import { environment } from "../environment";

export const useGetAllData = () => {
  // Queries
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["get-all-data"],
    queryFn: () => {
      return Axios.get(environment.api + "all-data").then((res) => res.data);
    },
  });

  return { data, isLoading, refetch };
};
